import React, { Component } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./WelcomeBoard.css";

export default class WelcomeBoard extends Component {
  render() {
    return (
      <div className="card card-custom card-stretch">
        <div className="card-body">
          <div
            className="scroll-y mr-n5 pr-5 h-550px mb-5"
            style={{ maxHeight: "619px" }}
          >
            <div className="d-flex flex-column align-items-center">
              {!this.props.currentUserAvatar ? (
                <img
                  className="avatarWelcome"
                  src={this.props.currentUserAvatar}
                  alt="icon avatar"
                />
              ) : (
                <span className="textDesciptionWelcome mt-md-10 text-muted text-center my-auto">
                  Your Messages <br/>
                  Send private photos and messages to a Trucker.
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
